<div class="imprint-header">
  <div class="imprint-header-title">
    <span>Impressum</span>
  </div>
</div>

<div class="imprint-content">
  <span [innerHtml]="imprintText"></span>
</div>